(() => {
  'use strict';

  const root = document.querySelector('[data-cart-page]');
  if (!root) return;

  const routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const route = (path) => `${routesRoot}${String(path || '').replace(/^\//, '')}`;
  let busy = false;

  const setBusy = (value) => {
    busy = value;
    root.classList.toggle('is-loading', value);
    root.setAttribute('aria-busy', value ? 'true' : 'false');
  };

  async function changeLine(key, quantity, input) {
    if (busy || !key) return;
    const nextQuantity = Math.max(0, Number(quantity || 0));
    if (input) input.value = String(nextQuantity);

    setBusy(true);
    try {
      const response = await fetch(route('cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: nextQuantity })
      });
      if (!response.ok) throw new Error('Cart update failed');
      window.location.reload();
    } catch (_) {
      const fallback = document.querySelector('#megetize-cart-form');
      if (fallback) fallback.submit();
      else window.location.reload();
    }
  }

  root.addEventListener('click', (event) => {
    const control = event.target.closest('[data-cart-change]');
    if (!control) return;

    event.preventDefault();
    const key = control.dataset.lineKey;
    const item = control.closest('[data-cart-item]');
    const input = item && item.querySelector('[data-cart-quantity]');
    const current = Number((input && input.value) || 1);
    const action = control.dataset.cartChange;
    const next = action === 'remove' ? 0 : action === 'increase' ? current + 1 : Math.max(0, current - 1);
    changeLine(key, next, input);
  });

  root.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    changeLine(input.dataset.lineKey, Math.max(0, Number(input.value || 0)), input);
  });
})();
